export default __webpack_public_path__ + "images/0xa61beb4a3d02decb01039e378237032b351125b4.png";